var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HelpRegistriesCovid',{attrs:{"header-additional-text":_vm.$t('help_registries.covid.inserted').toString(),"api-read":"/api/help_registries/covid/index_pagination_provider","cb_help_status_id":3}})}
var staticRenderFns = []

export { render, staticRenderFns }